import { ProducerWaitPolicy, RequestedContextCardinality } from '@augloop/interfaces';
export const getContextTypes = (requestedContextTypesRules, cardinality) => {
    const contextTypes = [];
    for (const requestedContextTypesRule of requestedContextTypesRules !== null && requestedContextTypesRules !== void 0 ? requestedContextTypesRules : []) {
        if (cardinality !== undefined && cardinality !== requestedContextTypesRule.cardinality) {
            continue;
        }
        for (const type of requestedContextTypesRule.contextTypes) {
            contextTypes.push([type, requestedContextTypesRule.cardinality, requestedContextTypesRule.producerWaitPolicy]);
        }
    }
    return contextTypes;
};
export const getWaitedContextTypes = (requestedContextTypesRules) => {
    let contextTypes = [];
    for (const requestedContextTypesRule of requestedContextTypesRules !== null && requestedContextTypesRules !== void 0 ? requestedContextTypesRules : []) {
        if (requestedContextTypesRule.cardinality === RequestedContextCardinality.Required || requestedContextTypesRule.producerWaitPolicy === ProducerWaitPolicy.Always) {
            contextTypes = contextTypes.concat(requestedContextTypesRule.contextTypes);
        }
    }
    return contextTypes;
};
//# sourceMappingURL=requested-contexts-util.js.map